<h2>{{ 'LICENCE_CHECKING.driverDetails' | translateOrFallback:'Driver Details' }}</h2>

<vrm-basic-table [data]="dataSource" [columns]="columns">
  <ng-container matColumnDef="firstName">
    <th mat-header-cell *matHeaderCellDef>{{ 'REPORTCOLUMNS.firstName' | translateOrFallback:'First Name' }}</th>
    <td mat-cell *matCellDef="let row">{{ row.firstName }}</td>
  </ng-container>

  <ng-container matColumnDef="lastName">
    <th mat-header-cell *matHeaderCellDef>{{ 'REPORTCOLUMNS.lastName' | translateOrFallback:'Last Name' }}</th>
    <td mat-cell *matCellDef="let row">{{ row.lastName }}</td>
  </ng-container>

  <ng-container matColumnDef="pin">
    <th mat-header-cell *matHeaderCellDef>{{ 'REPORTCOLUMNS.employeeNumber' | translateOrFallback:'Employee Number' }}</th>
    <td mat-cell *matCellDef="let row">{{ row.pin }}</td>
  </ng-container>

  <ng-container matColumnDef="lastCheckDate">
    <th mat-header-cell *matHeaderCellDef>{{ 'REPORTCOLUMNS.licenceLastChecked' | translateOrFallback:'Licence Last Checked' }}</th>
    <td
      mat-cell
      *matCellDef="let row"
      [amberText]="row.hasOldCheck"
    >{{ row.lastCheckDate }}</td>
  </ng-container>

  <ng-container matColumnDef="mandateExpiryDate">
    <th mat-header-cell *matHeaderCellDef>{{ 'REPORTCOLUMNS.mandateValidUntil' | translateOrFallback:'Mandate Valid Until' }}</th>
    <td
      mat-cell
      *matCellDef="let row"
      [greenText]="row.mandateExpiryRiskLevel === LicenceExpiryRiskLevel.Low"
      [amberText]="row.mandateExpiryRiskLevel === LicenceExpiryRiskLevel.Medium"
      [redText]="row.mandateExpiryRiskLevel === LicenceExpiryRiskLevel.High"
    >{{ row.mandateExpiryDate }}</td>
  </ng-container>

  <ng-container matColumnDef="issueNumber">
    <th mat-header-cell *matHeaderCellDef>{{ 'REPORTCOLUMNS.issueNumber' | translateOrFallback:'Licence Issue Number' }}</th>
    <td mat-cell *matCellDef="let row">{{ row.issueNumber }}</td>
  </ng-container>

  <ng-container matColumnDef="licenceStatus">
    <th mat-header-cell *matHeaderCellDef>{{ 'REPORTCOLUMNS.type' | translateOrFallback:'Licence Type' }}</th>
    <td
      mat-cell
      *matCellDef="let row"
      [redText]="row.hasHighRiskLicenceStatus"
    >{{ row.licenceStatus }}</td>
  </ng-container>

  <ng-container matColumnDef="licenceExpiryDate">
    <th mat-header-cell *matHeaderCellDef>{{ 'REPORTCOLUMNS.licenceExpiry' | translateOrFallback:'Licence Expiry' }}</th>
    <td
      mat-cell
      *matCellDef="let row"
      [greenText]="row.licenceExpiryRiskLevel === LicenceExpiryRiskLevel.Low"
      [amberText]="row.licenceExpiryRiskLevel === LicenceExpiryRiskLevel.Medium"
      [redText]="row.licenceExpiryRiskLevel === LicenceExpiryRiskLevel.High"
    >{{ row.licenceExpiryDate }}</td>
  </ng-container>
</vrm-basic-table>
